import {
  CLONE_PRODUCT,
  CLONE_PRODUCT_FAILED,
  CLONE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_CATEGORY,
  CREATE_PRODUCT_CATEGORY_FAILED,
  CREATE_PRODUCT_CATEGORY_SUCCESS,
  CREATE_PRODUCT_SUCCESS,
  DELETE_PRODUCT,
  DELETE_PRODUCT_FAILED,
  DELETE_PRODUCT_SUCCESS,
  GET_CATEGORY_FOR_FORM,
  GET_CATEGORY_FOR_FORM_FAILED,
  GET_CATEGORY_FOR_FORM_SUCCESS,
  GET_FEATURE_RECIPIENTS,
  GET_FEATURE_RECIPIENTS_FAILED,
  GET_FEATURE_RECIPIENTS_SUCCESS,
  GET_ORDER,
  GET_ORDER_DETAILS,
  GET_ORDER_DETAILS_FAILED,
  GET_ORDER_DETAILS_SUCCESS,
  GET_ORDER_FAILED,
  GET_ORDER_SUCCESS,
  GET_PRODUCT,
  GET_PRODUCTS,
  GET_PRODUCTS_FAILED,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCT_CATEGORY,
  GET_PRODUCT_CATEGORY_FAILED,
  GET_PRODUCT_CATEGORY_SUCCESS,
  GET_PRODUCT_FAILED,
  GET_PRODUCT_ORDERS,
  GET_PRODUCT_ORDERS_FAILED,
  GET_PRODUCT_ORDERS_SUCCESS,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_USER_TAGS,
  GET_PRODUCT_USER_TAGS_FAILED,
  GET_PRODUCT_USER_TAGS_SUCCESS,
  GET_STRIPE_PRICES,
  GET_STRIPE_PRICES_FAILED,
  GET_STRIPE_PRICES_SUCCESS,
  GET_STRIPE_PRODUCTS,
  GET_STRIPE_PRODUCTS_FAILED,
  GET_STRIPE_PRODUCTS_SUCCESS,
  GET_TEASER_PRODUCTS,
  GET_TEASER_PRODUCTS_FAILED,
  GET_TEASER_PRODUCTS_SUCCESS,
  HIDE_CLONE_PRODUCT_MODAL,
  HIDE_DELETE_PRODUCT_MODAL,
  OPEN_CLONE_PRODUCT_MODAL,
  OPEN_DELETE_PRODUCT_MODAL,
  RESET_CATEGORY_FOR_FORM,
  RESET_FEATURE_RECIPIENTS,
  RESET_ORDER,
  RESET_ORDER_DETAILS,
  RESET_PRODUCT,
  RESET_PRODUCT_CATEGORY,
  RESET_PRODUCT_USER_TAGS,
  RESET_STRIPE_PRICES,
  RESET_TEASER_PRODUCTS,
  SET_ORDER_CHECKOUT_SESSION,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_CATEGORY,
  UPDATE_PRODUCT_CATEGORY_FAILED,
  UPDATE_PRODUCT_CATEGORY_SUCCESS,
  UPDATE_PRODUCT_FAILED,
  UPDATE_PRODUCT_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  loading: false,
  error: "",
  orders: null,
  products: null,
  stripeProducts: null,
  stripePrices: null,
  deleteProductModalIsOpen: false,
  selectedProduct: null,
  featureRecipients: [],
  selectedProductCategory: null,
  orderDetails: null,
  categoryForForm: null,
  teaserProducts: [],
  order: null,
  productUserTags: [],
  orderCheckoutSession: null,
  cloneProductModalIsOpen: false,
}

const ProductsAndSubscriptions = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCT_ORDERS:
    case GET_PRODUCTS:
    case GET_STRIPE_PRODUCTS:
    case GET_STRIPE_PRICES:
    case DELETE_PRODUCT:
    case GET_PRODUCT:
    case GET_FEATURE_RECIPIENTS:
    case UPDATE_PRODUCT:
    case CREATE_PRODUCT_CATEGORY:
    case UPDATE_PRODUCT_CATEGORY:
    case GET_PRODUCT_CATEGORY:
    case GET_ORDER_DETAILS:
    case GET_CATEGORY_FOR_FORM:
    case GET_TEASER_PRODUCTS:
    case GET_ORDER:
    case GET_PRODUCT_USER_TAGS:
    case CLONE_PRODUCT:
      return {
        ...state,
        loading: true,
      }
    case GET_PRODUCT_ORDERS_FAILED:
    case GET_PRODUCTS_FAILED:
    case GET_STRIPE_PRODUCTS_FAILED:
    case GET_STRIPE_PRICES_FAILED:
    case DELETE_PRODUCT_FAILED:
    case GET_PRODUCT_FAILED:
    case GET_FEATURE_RECIPIENTS_FAILED:
    case UPDATE_PRODUCT_FAILED:
    case CREATE_PRODUCT_CATEGORY_FAILED:
    case UPDATE_PRODUCT_CATEGORY_FAILED:
    case GET_PRODUCT_CATEGORY_FAILED:
    case GET_ORDER_DETAILS_FAILED:
    case GET_CATEGORY_FOR_FORM_FAILED:
    case GET_TEASER_PRODUCTS_FAILED:
    case GET_ORDER_FAILED:
    case GET_PRODUCT_USER_TAGS_FAILED:
    case CLONE_PRODUCT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case GET_PRODUCT_ORDERS_SUCCESS:
      return {
        ...state,
        orders: action.payload,
        loading: false,
      }
    case GET_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: action.payload,
        loading: false,
      }
    case GET_STRIPE_PRODUCTS_SUCCESS:
      return {
        ...state,
        stripeProducts: action.payload,
        loading: false,
      }
    case GET_STRIPE_PRICES_SUCCESS:
      return {
        ...state,
        stripePrices: action.payload,
        loading: false,
      }
    case RESET_STRIPE_PRICES:
      return {
        ...state,
        stripePrices: null,
      }
    case DELETE_PRODUCT_SUCCESS:
    case CLONE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case OPEN_DELETE_PRODUCT_MODAL:
      return {
        ...state,
        deleteProductModalIsOpen: true,
      }
    case HIDE_DELETE_PRODUCT_MODAL:
      return {
        ...state,
        deleteProductModalIsOpen: false,
      }
    case GET_PRODUCT_SUCCESS:
      return {
        ...state,
        selectedProduct: action.payload,
        loading: false,
      }
    case RESET_PRODUCT:
      return {
        ...state,
        selectedProduct: null,
      }
    case GET_FEATURE_RECIPIENTS_SUCCESS:
      return {
        ...state,
        featureRecipients: action.payload,
        loading: false,
      }
    case RESET_FEATURE_RECIPIENTS:
      return {
        ...state,
        featureRecipients: [],
      }
    case CREATE_PRODUCT_CATEGORY_SUCCESS:
    case UPDATE_PRODUCT_CATEGORY_SUCCESS:
    case GET_PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state,
        selectedProductCategory: action.payload,
        loading: false,
      }
    case RESET_PRODUCT_CATEGORY:
      return {
        ...state,
        selectedProductCategory: null,
      }
    case CREATE_PRODUCT_SUCCESS:
    case UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        selectedProduct: action?.payload?.values,
        featureRecipients: action?.payload?.user_ids || [],
      }
    case GET_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        orderDetails: action.payload,
        loading: false,
      }
    case RESET_ORDER_DETAILS:
      return {
        ...state,
        orderDetails: null,
      }
    case GET_CATEGORY_FOR_FORM_SUCCESS:
      return {
        ...state,
        categoryForForm: action.payload,
        loading: false,
      }
    case RESET_CATEGORY_FOR_FORM:
      return {
        ...state,
        categoryForForm: null,
      }
    case GET_TEASER_PRODUCTS_SUCCESS:
      return {
        ...state,
        teaserProducts: action.payload,
        loading: false,
      }
    case RESET_TEASER_PRODUCTS:
      return {
        ...state,
        teaserProducts: [],
      }
    case GET_ORDER_SUCCESS:
      return {
        ...state,
        order: action.payload,
        loading: false,
      }
    case RESET_ORDER:
      return {
        ...state,
        order: null,
      }
    case GET_PRODUCT_USER_TAGS_SUCCESS:
      return {
        ...state,
        productUserTags: action.payload,
        loading: false,
      }
    case RESET_PRODUCT_USER_TAGS:
      return {
        ...state,
        productUserTags: [],
      }
    case SET_ORDER_CHECKOUT_SESSION:
      return {
        ...state,
        orderCheckoutSession: action.payload,
      }
    case OPEN_CLONE_PRODUCT_MODAL:
      return {
        ...state,
        cloneProductModalIsOpen: true,
      }
    case HIDE_CLONE_PRODUCT_MODAL:
      return {
        ...state,
        cloneProductModalIsOpen: false,
      }
    default:
      return state
  }
}

export default ProductsAndSubscriptions
